import React from 'react';
import PropTypes from 'prop-types';
import { withFormik, Field } from 'formik';
import { get, join } from 'lodash';
import Yup from 'yup';
import {
  AddressForm,
  getAddressValidation,
  Button,
  ButtonWrapper,
  Form,
  GridItem,
  FormButtons,
  GridContainer,
  ErrorMessage,
  NameForm,
  getNameValidation,
  TextFieldWrapper,
} from '../../common';
import { getFormValue } from '../../../util/helpers';
import BirthdayField, { getBirthdayValidation } from './BirthdayField';
import GenderField, { getGenderValidation } from './GenderField';
import SpecialCareConcern from './SpecialCareConcern';

const CHILDINFO_NOTES = 'notes';
class ChildInformationForm extends React.Component {
  handleCancel = () => {
    this.props.resetForm();
    this.props.onCancel();
  };

  render() {
    const {
      handleSubmit,
      isEditing,
      setFieldValue,
      status,
      values,
    } = this.props;
    const submitButtonText = isEditing ? 'Save' : 'Save & Continue';

    return (
      <Form onSubmit={handleSubmit}>
        <GridContainer>
          <NameForm firstNameRequired lastNameRequired />
          <BirthdayField
            required
            setFieldValue={setFieldValue}
            values={values}
          />
          <GenderField />
          <AddressForm required={false} />
          <SpecialCareConcern />
          <GridItem lg={12} xs={12}>
            <Field
              component={TextFieldWrapper}
              id={CHILDINFO_NOTES}
              label="Notes"
              multiline
              name={CHILDINFO_NOTES}
            />
          </GridItem>
        </GridContainer>
        {get(status, 'saveError') && (
          <ErrorMessage>{status.saveError}</ErrorMessage>
        )}
        <FormButtons>
          <ButtonWrapper>
            <Button type="submit">{submitButtonText}</Button>
          </ButtonWrapper>
          {isEditing && (
            <ButtonWrapper marginLeft>
              <Button
                color="default"
                onClick={this.handleCancel}
                variant="text"
              >
                Cancel
              </Button>
            </ButtonWrapper>
          )}
        </FormButtons>
      </Form>
    );
  }
}

ChildInformationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
  values: PropTypes.object.isRequired,
  additionalNotes: PropTypes.string,
  addressId: PropTypes.number,
  addressState: PropTypes.string,
  birthday: PropTypes.string,
  city: PropTypes.string,
  firstName: PropTypes.string,
  gender: PropTypes.string,
  isEditing: PropTypes.bool,
  lastName: PropTypes.string,
  notes: PropTypes.string,
  secondaryStreetAddress: PropTypes.string,
  status: PropTypes.object,
  streetAddress: PropTypes.string,
  zipCode: PropTypes.string,
};

ChildInformationForm.defaultProps = {
  additionalNotes: '',
  addressId: undefined,
  addressState: '',
  birthday: '',
  city: '',
  firstName: '',
  gender: '',
  isEditing: false,
  lastName: '',
  notes: '',
  secondaryStreetAddress: '',
  status: {},
  streetAddress: '',
  userId: undefined,
  zipCode: '',
};

export default withFormik({
  displayName: 'Child',
  handleSubmit: (values, { props, setStatus }) => {
    return props
      .onSave({
        ...values,
        addressId: props.addressId,
        id: props.id,
        userId: props.userId,
      })
      .then(() => (props.isEditing ? props.onCancel() : props.onContinue()))
      .catch(error => setStatus({ saveError: error }));
  },
  mapPropsToValues: props => {
    return {
      addressState: getFormValue(props, 'addressState', ''),
      birthday: getFormValue(props, 'birthday', ''),
      city: getFormValue(props, 'city', ''),
      firstName: getFormValue(props, 'firstName', ''),
      gender: getFormValue(props, 'gender', ''),
      lastName: getFormValue(props, 'lastName', ''),
      secondaryStreetAddress: getFormValue(props, 'secondaryStreetAddress', ''),
      streetAddress: getFormValue(props, 'streetAddress', ''),
      additionalNotes: getFormValue(props, 'additionalNotes', ''),
      notes: getFormValue(props, 'notes', ''),
      zipCode: getFormValue(props, 'zipCode', ''),
    };
  },
  validationSchema: Yup.object().shape({
    ...getAddressValidation({ required: false }),
    ...getNameValidation({ firstNameRequired: true, lastNameRequired: true }),
    ...getBirthdayValidation({ required: true }),
    ...getGenderValidation(),
  }),
})(ChildInformationForm);



// WEBPACK FOOTER //
// ./src/modules/ChildInformationPage/components/ChildInformationForm.js